// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationManagement-space1-rtfjw {
	margin-bottom: 6px !important;
}

.PopularLocationManagement-space2-e9pT4 {
	margin-bottom: 12px !important;
}

.PopularLocationManagement-space3-NcFal {
	margin-bottom: 18px !important;
}

.PopularLocationManagement-space4-L4uZ_ {
	margin-bottom: 24px !important;
}

.PopularLocationManagement-space5-BOOIW {
	margin-bottom: 30px !important;
}

.PopularLocationManagement-space6-z6dGo {
	margin-bottom: 36px !important;
}

.PopularLocationManagement-space7-wEB8W {
	margin-bottom: 42px !important;
}

.PopularLocationManagement-space8-rDpmS {
	margin-bottom: 48px !important;
}

.PopularLocationManagement-spaceTop1-gqjFy {
	margin-top: 6px !important;
}

.PopularLocationManagement-spaceTop2-ysiLE {
	margin-top: 12px !important;
}

.PopularLocationManagement-spaceTop3-fbYVj {
	margin-top: 18px !important;
}

.PopularLocationManagement-spaceTop4-R55Lb {
	margin-top: 24px !important;
}

.PopularLocationManagement-spaceTop5-CFgcn {
	margin-top: 30px !important;
}

.PopularLocationManagement-spaceTop6-s3g7b {
	margin-top: 36px !important;
}

.PopularLocationManagement-spaceTop7-QhFLp {
	margin-top: 42px !important;
}

.PopularLocationManagement-spaceTop8-TNwqW {
	margin-top: 48px !important;
}

.PopularLocationManagement-noMargin-gMwdR {
	margin: 0px !important;
}

.PopularLocationManagement-padding1-C7pHD {
	padding-bottom: 6px !important;
}

.PopularLocationManagement-padding2-_RMNA {
	padding-bottom: 12px !important;
}

.PopularLocationManagement-padding3-Zi8B3 {
	padding-bottom: 18px !important;
}

.PopularLocationManagement-padding4-iSBLc {
	padding-bottom: 24px !important;
}

.PopularLocationManagement-padding5-wY88i {
	padding-bottom: 30px !important;
}

.PopularLocationManagement-padding6-KN_wt {
	padding-bottom: 36px !important;
}

.PopularLocationManagement-padding7-bQqk6 {
	padding-bottom: 42px !important;
}

.PopularLocationManagement-paddingTop1-vkGir {
	padding-top: 6px !important;
}

.PopularLocationManagement-paddingTop2-tR7b7 {
	padding-top: 12px !important;
}

.PopularLocationManagement-paddingTop3-SOKwB {
	padding-top: 18px !important;
}

.PopularLocationManagement-paddingTop4-ZHfsF {
	padding-top: 24px !important;
}

.PopularLocationManagement-paddingTop5-gNdnP {
	padding-top: 30px !important;
}

.PopularLocationManagement-paddingTop6-OpHjJ {
	padding-top: 36px !important;
}

.PopularLocationManagement-paddingTop7-AgCL9 {
	padding-top: 42px !important;
}

.PopularLocationManagement-noPadding-eeV6t {
	padding: 0px !important;
}

.PopularLocationManagement-spaceMarginBottom0-w6oEi {
	margin-bottom: 0;
}

.PopularLocationManagement-textBold-t63pF {
	font-weight: 500 !important;
}

.PopularLocationManagement-textBolder-b32HR {
	font-weight: 700 !important;
}

.PopularLocationManagement-textNormal-gYBQU {
	font-weight: normal !important;
}

/*New Design Text Colors */

.PopularLocationManagement-textDarkBlue-QGukd {
	color: rgb(20, 39, 94) !important;
}

.PopularLocationManagement-textLightBlue-MG92f {
	color: rgb(57, 87, 106) !important;
}

.PopularLocationManagement-textLightSandleGreen-SFkoT {
	color: rgb(76, 86, 41) !important;
}

.PopularLocationManagement-textLightBrown-JfjHh {
	color: rgb(115, 79, 33) !important;
}

.PopularLocationManagement-textMediumMaroon-x5dCE {
	color: rgb(87, 37, 51) !important;
}

.PopularLocationManagement-textBrown-oOtbE {
	color: rgb(160, 47, 24) !important;
}

.PopularLocationManagement-textMaroon-VzMCb {
	color: rgb(155, 49, 67) !important;
}

.PopularLocationManagement-textDarkBrown-xsyk7 {
	color: rgb(83, 18, 16) !important;
}

.PopularLocationManagement-textMediumBrown-xOb2d {
	color: rgb(142, 28, 10) !important;
}

.PopularLocationManagement-textSkyBlue-tHVjA {
	color: rgb(37, 117, 141) !important;
}

.PopularLocationManagement-textGray-z_x6m {
	color: rgb(77, 65, 51) !important;
}

.PopularLocationManagement-errorMessage-r80XW {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.PopularLocationManagement-userText-xPM3m {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.PopularLocationManagement-panelHeader-Z_MtQ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.PopularLocationManagement-exportSection-r2bgE {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.PopularLocationManagement-exportSectionGridSub-usPmO {
	grid-template-columns: 50% 49% !important;
}

.PopularLocationManagement-exportText-a6qdu {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.PopularLocationManagement-exportLinkImg-Jr2GF {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.PopularLocationManagement-exportImg-UUbmO {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.PopularLocationManagement-linkBtn-qYnPt {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.PopularLocationManagement-table-oLwrT {
	display: table;
}

.PopularLocationManagement-tableRow-K_9gi {
	display: table-row;
}

.PopularLocationManagement-tableCell-JBk54 {
	display: table-cell;
	float: none;
}

.PopularLocationManagement-formGroup-NkckD {
	margin-bottom: 6px;
}

.PopularLocationManagement-marginTop0-AOEwI {
	margin-top: 0;
}

.PopularLocationManagement-marginBottom20-xPgK6 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.PopularLocationManagement-bannerImageBg-TefHT {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.PopularLocationManagement-bannerDelete-cjKjQ {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.PopularLocationManagement-exportLink-QPH4f {
	padding-top: 10px;
	padding-right: 10px;
}

.PopularLocationManagement-seachContent-Cb5cM {
	padding-left: 0px;
	margin-bottom: 5px;
}

.PopularLocationManagement-marginBottom9-RUHAP {
	margin-bottom: 9px;
}

.PopularLocationManagement-spaceTop52-B_9Ey {
	margin-top: 52px;
}

.PopularLocationManagement-profileViewInner-Q7XuD {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.PopularLocationManagement-profileViewMain-fRwCa {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.PopularLocationManagement-profileViewlabel-tpBno {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.PopularLocationManagement-profileViewMainContent-gxjD4 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.PopularLocationManagement-reviewsFormStar-l0Lpr {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.PopularLocationManagement-reviewsFormStar-l0Lpr svg {
	cursor: pointer;
}

.PopularLocationManagement-addLanguageText-exEN5 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.PopularLocationManagement-exportSection-r2bgE {
		grid-template-columns: 100%;
	}

	.PopularLocationManagement-spaceTop52-B_9Ey {
		margin-top: 18px;
	}

	.PopularLocationManagement-exportText-a6qdu {
		float: none;
		margin-top: 12px;
	}

	.PopularLocationManagement-exportSectionGridSub-usPmO {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.PopularLocationManagement-profileViewlabel-tpBno {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.PopularLocationManagement-profileViewMainContent-gxjD4 {
		width: 100%;
		text-align: center;
	}

	.PopularLocationManagement-panelHeader-Z_MtQ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `PopularLocationManagement-space1-rtfjw`,
	"space2": `PopularLocationManagement-space2-e9pT4`,
	"space3": `PopularLocationManagement-space3-NcFal`,
	"space4": `PopularLocationManagement-space4-L4uZ_`,
	"space5": `PopularLocationManagement-space5-BOOIW`,
	"space6": `PopularLocationManagement-space6-z6dGo`,
	"space7": `PopularLocationManagement-space7-wEB8W`,
	"space8": `PopularLocationManagement-space8-rDpmS`,
	"spaceTop1": `PopularLocationManagement-spaceTop1-gqjFy`,
	"spaceTop2": `PopularLocationManagement-spaceTop2-ysiLE`,
	"spaceTop3": `PopularLocationManagement-spaceTop3-fbYVj`,
	"spaceTop4": `PopularLocationManagement-spaceTop4-R55Lb`,
	"spaceTop5": `PopularLocationManagement-spaceTop5-CFgcn`,
	"spaceTop6": `PopularLocationManagement-spaceTop6-s3g7b`,
	"spaceTop7": `PopularLocationManagement-spaceTop7-QhFLp`,
	"spaceTop8": `PopularLocationManagement-spaceTop8-TNwqW`,
	"noMargin": `PopularLocationManagement-noMargin-gMwdR`,
	"padding1": `PopularLocationManagement-padding1-C7pHD`,
	"padding2": `PopularLocationManagement-padding2-_RMNA`,
	"padding3": `PopularLocationManagement-padding3-Zi8B3`,
	"padding4": `PopularLocationManagement-padding4-iSBLc`,
	"padding5": `PopularLocationManagement-padding5-wY88i`,
	"padding6": `PopularLocationManagement-padding6-KN_wt`,
	"padding7": `PopularLocationManagement-padding7-bQqk6`,
	"paddingTop1": `PopularLocationManagement-paddingTop1-vkGir`,
	"paddingTop2": `PopularLocationManagement-paddingTop2-tR7b7`,
	"paddingTop3": `PopularLocationManagement-paddingTop3-SOKwB`,
	"paddingTop4": `PopularLocationManagement-paddingTop4-ZHfsF`,
	"paddingTop5": `PopularLocationManagement-paddingTop5-gNdnP`,
	"paddingTop6": `PopularLocationManagement-paddingTop6-OpHjJ`,
	"paddingTop7": `PopularLocationManagement-paddingTop7-AgCL9`,
	"noPadding": `PopularLocationManagement-noPadding-eeV6t`,
	"spaceMarginBottom0": `PopularLocationManagement-spaceMarginBottom0-w6oEi`,
	"textBold": `PopularLocationManagement-textBold-t63pF`,
	"textBolder": `PopularLocationManagement-textBolder-b32HR`,
	"textNormal": `PopularLocationManagement-textNormal-gYBQU`,
	"textDarkBlue": `PopularLocationManagement-textDarkBlue-QGukd`,
	"textLightBlue": `PopularLocationManagement-textLightBlue-MG92f`,
	"textLightSandleGreen": `PopularLocationManagement-textLightSandleGreen-SFkoT`,
	"textLightBrown": `PopularLocationManagement-textLightBrown-JfjHh`,
	"textMediumMaroon": `PopularLocationManagement-textMediumMaroon-x5dCE`,
	"textBrown": `PopularLocationManagement-textBrown-oOtbE`,
	"textMaroon": `PopularLocationManagement-textMaroon-VzMCb`,
	"textDarkBrown": `PopularLocationManagement-textDarkBrown-xsyk7`,
	"textMediumBrown": `PopularLocationManagement-textMediumBrown-xOb2d`,
	"textSkyBlue": `PopularLocationManagement-textSkyBlue-tHVjA`,
	"textGray": `PopularLocationManagement-textGray-z_x6m`,
	"errorMessage": `PopularLocationManagement-errorMessage-r80XW`,
	"userText": `PopularLocationManagement-userText-xPM3m`,
	"panelHeader": `PopularLocationManagement-panelHeader-Z_MtQ`,
	"exportSection": `PopularLocationManagement-exportSection-r2bgE`,
	"exportSectionGridSub": `PopularLocationManagement-exportSectionGridSub-usPmO`,
	"exportText": `PopularLocationManagement-exportText-a6qdu`,
	"exportLinkImg": `PopularLocationManagement-exportLinkImg-Jr2GF`,
	"exportImg": `PopularLocationManagement-exportImg-UUbmO`,
	"linkBtn": `PopularLocationManagement-linkBtn-qYnPt`,
	"table": `PopularLocationManagement-table-oLwrT`,
	"tableRow": `PopularLocationManagement-tableRow-K_9gi`,
	"tableCell": `PopularLocationManagement-tableCell-JBk54`,
	"formGroup": `PopularLocationManagement-formGroup-NkckD`,
	"marginTop0": `PopularLocationManagement-marginTop0-AOEwI`,
	"marginBottom20": `PopularLocationManagement-marginBottom20-xPgK6`,
	"bannerImageBg": `PopularLocationManagement-bannerImageBg-TefHT`,
	"bannerDelete": `PopularLocationManagement-bannerDelete-cjKjQ`,
	"exportLink": `PopularLocationManagement-exportLink-QPH4f`,
	"seachContent": `PopularLocationManagement-seachContent-Cb5cM`,
	"marginBottom9": `PopularLocationManagement-marginBottom9-RUHAP`,
	"spaceTop52": `PopularLocationManagement-spaceTop52-B_9Ey`,
	"profileViewInner": `PopularLocationManagement-profileViewInner-Q7XuD`,
	"profileViewMain": `PopularLocationManagement-profileViewMain-fRwCa`,
	"profileViewlabel": `PopularLocationManagement-profileViewlabel-tpBno`,
	"profileViewMainContent": `PopularLocationManagement-profileViewMainContent-gxjD4`,
	"reviewsFormStar": `PopularLocationManagement-reviewsFormStar-l0Lpr`,
	"addLanguageText": `PopularLocationManagement-addLanguageText-exEN5`
};
module.exports = ___CSS_LOADER_EXPORT___;
